export const getProfileEditorModeMeta = (mode, t = (k, f) => f) => {
    if (mode === 'training') {
        return {
            isEditing: true,
            title: t('profileEditor.modeTraining.title', 'Training Settings'),
            description: t('profileEditor.modeTraining.description', 'Update exercise familiarity, weekly activity, sessions per week, and preferred workout days only.'),
            badgeTone: 'warning',
            badgeLabel: t('profileEditor.modeTraining.badgeLabel', 'Training focus')
        };
    }

    if (mode === 'full') {
        return {
            isEditing: true,
            title: t('profileEditor.modeFull.title', 'Profile Editor'),
            description: t('profileEditor.modeFull.description', 'Saving here updates your profile without automatically rebuilding your quest plan.'),
            badgeTone: 'warning',
            badgeLabel: t('profileEditor.modeFull.badgeLabel', 'Edit mode')
        };
    }

    return {
        isEditing: false,
        title: t('profileEditor.modeRequired.title', 'Profile Editor'),
        description: t('profileEditor.modeRequired.description', 'Saving here updates your profile without automatically rebuilding your quest plan.'),
        badgeTone: 'neutral',
        badgeLabel: t('profileEditor.modeRequired.badgeLabel', 'Profile required')
    };
};
